import {assert} from 'assert-ts';
import type {WorkMetadata} from 'services/metadata/types';
import {isWorkMetadataValue} from './isWorkMetadataValue';

export const assertWorkMetadataValue = (value: unknown): WorkMetadata => {
  assert(
    isWorkMetadataValue(value),
    'assertWorkMetadataValue: invalid work metadata',
    {value},
  );

  return value as WorkMetadata;
};
